module.exports = __webpack_public_path__ + "images/video-cover.jpg?9911f";